module.exports = __webpack_public_path__ + "static/media/logo.ef19181a.png";